'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ItemList = require('./ItemList.scss');

var _ItemList2 = _interopRequireDefault(_ItemList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ItemList, _Component);

  function ItemList() {
    (0, _classCallCheck3.default)(this, ItemList);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ItemList).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var items = _props.items;
      var mode = _props.mode;
      var isLoading = _props.isLoading;
      var editedItems = _props.editedItems;


      if (!items) {
        return _react2.default.createElement('div', null);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { position: 'relative' } },
          isLoading === true && _react2.default.createElement(
            'div',
            { className: _ItemList2.default.loading },
            _react2.default.createElement('div', { className: _ItemList2.default.loader }),
            _react2.default.createElement(
              'p',
              null,
              'Loading items...'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_ItemList2.default.content, (0, _defineProperty3.default)({}, _ItemList2.default.edit, mode === 'edit')) },
            _react2.default.createElement(
              'div',
              { className: 'grid', style: { paddingBottom: '30px' } },
              items && items.map(function (item) {
                return _react2.default.createElement(
                  'div',
                  { className: 'col--1-of-2', key: item.id },
                  _react2.default.createElement(_components.Item, {
                    info: item,
                    needEdit: mode === 'edit' ? editedItems[item.id] ? false : true : false,
                    mode: mode,
                    onDelete: function onDelete(id) {
                      return _this2.props.onDelete(id);
                    },
                    onEdit: function onEdit(id, item) {
                      return _this2.props.onEdit(id, item);
                    } })
                );
              })
            )
          )
        )
      );
    }
  }]);
  return ItemList;
}(_react.Component), _class.propTypes = {
  items: _react.PropTypes.array
}, _class.defaultProps = {
  mode: "view",
  isLoading: false
}, _temp);
exports.default = ItemList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ItemList/ItemList.js
 ** module id = 1100
 ** module chunks = 0
 **/